module.exports = __webpack_public_path__ + "static/img/pic3.a6f0f56.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/static/image/index/pic3.jpg
// module id = L4/3
// module chunks = 1